/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/display-name */
// TODO: Fix accessibility
// TODO: Fix display name

import './filter-button-dropdown.component.scss';
import {
  DetailedHTMLProps,
  HTMLAttributes,
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { ButtonGroup, Dropdown, Form, Spinner } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import {
  FilterOptionSelectedValue,
  FilterSelectedValue,
} from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { FILTER_TYPES } from '../../../../hooks/filters/interfaces/filter.interface';
import { useAppAsyncFilterOptions } from '../../../../hooks/filters/use-app-filter-options.hook';
import { useAppFilterSelectedValue } from '../../../../hooks/filters/use-app-filter-selected-value.hook';
import { setValue } from '../../../../services/get-filters.service';
import { MultipleSelectionOptionSimple } from '../../../dropdown/multiple-selection-option-group.component';
import { MultipleSelectionOptionsComponent } from '../../../dropdown/multiple-selection-options.component';
import { getIdClassNameHelper } from '../../helpers/get-id-class-name.helper';
import { FilterButtonComponentProps } from './filter-button-dropdown.component';

interface FilterButtonMenuComponentProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  label: string;
  isFetching?: boolean;
}
const FilterToggleButtonComponent = forwardRef<
  HTMLDivElement,
  FilterButtonMenuComponentProps
>(({ children, className, style, onClick }, ref) => {
  return (
    <div
      ref={ref}
      className={className}
      style={style}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick(e);
      }}
    >
      <div className="filter-toggle-button-input">
        <div className="filter-toggle-button-text">{children}</div>
      </div>
    </div>
  );
});

/**
 * TODO: make this component more reusable.
 * @param param0
 * @returns
 */
export const FilterButtonDropdownAdvComponent = ({
  onSelect,
  filter,
  filterSelection,
  disabled,
  variant = '',
  searchBox = true,
  defaultLabel = 'All',
}: FilterButtonComponentProps) => {
  const multiple = useMemo(
    () =>
      filter.type === FILTER_TYPES.ASYNC_MULTIPLE ||
      filter.type === FILTER_TYPES.MULTIPLE,
    [filter],
  );
  const isSingle = useMemo(
    () =>
      filter.type === FILTER_TYPES.ASYNC_SINGLE ||
      filter.type === FILTER_TYPES.SINGLE,
    [filter],
  );
  const isAsync = useMemo(
    () =>
      filter.type === FILTER_TYPES.ASYNC_MULTIPLE ||
      filter.type === FILTER_TYPES.ASYNC_SINGLE,
    [filter],
  );

  const [search, setSearch] = useState<string | undefined | null>(
    isAsync ? undefined : null,
  );
  const { options, isFetching } = useAppAsyncFilterOptions(
    filter.id,
    filterSelection,
    search,
  );
  const { selectedValue, setSelectedValue } = useAppFilterSelectedValue(
    filter.id,
  );
  const [selValue, setSelValue] = useState<FilterSelectedValue | undefined>();
  //const [, setError] = useState<string | null>(null)
  const [selectChange, setSelectChange] = useState<boolean | undefined>();

  const applyFilterCallback = useCallback(
    (selValue: FilterSelectedValue) => {
      if (selValue) {
        setSelValue(selValue);
        setSelectedValue(selValue);
        setSearch(undefined);
        setSelectChange(true);
      }
    },
    [setSelectedValue, setSelValue],
  );

  useEffect(() => {
    if (selectedValue && selectChange !== undefined) {
      if (onSelect) {
        onSelect(selectedValue);
      }
      setSelectChange(undefined);
    }
  }, [onSelect, selectedValue, selectChange]);

  useEffect(() => {
    if (selectedValue) {
      setSelValue(selectedValue);
    }
  }, [selectedValue, onSelect]);

  // const changeValueHandler = useCallback((selectedOptionValue: FilterOptionSelectedValue) => {
  //     if (selValue) {
  //         const values = [{ value: selectedOptionValue.value, label: selectedOptionValue.label }]
  //         const val: FilterSelectedValue = { ...selValue, values }
  //         if (filter.required && values.length === 0) {
  //             setError(`Required`)
  //         } else {
  //             setError(null)
  //             //setSelValue(val)
  //             applyFilterCallback(val)
  //         }
  //     }
  // }, [selValue, filter, applyFilterCallback])

  const changeMultipleValueHandler = useCallback(
    (selectedValue: FilterSelectedValue) => {
      setSelectedValue(selectedValue);
      //setSearch(undefined)
    },
    [setSelectedValue],
  );

  const onClickHandler = useCallback(() => {
    setSearch(null);
  }, []);

  const [searchValue, setSearchValue] = useState<string | undefined>(undefined);
  useEffect(() => {
    if (!searchValue) return;

    if (searchValue.trim() === '') {
      setSearch(null);
    } else {
      if (searchValue.trim().length > 4) {
        setSearch(searchValue);
      }
    }
  }, [searchValue]);

  const filterFunc = useCallback(
    (option: FilterOptionSelectedValue) => {
      if (!searchValue || !searchBox) return true;
      return (
        option.label.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
      );
    },
    [searchValue, searchBox],
  );

  const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined);

  const onToggleCallback = useCallback(
    (isOpen: boolean) => {
      if (selValue && multiple && isOpen === false) {
        // console.log("Apply on outside click", selValue)
        applyFilterCallback(selValue);
        //setSelectedValue(selValue)
        setSearch(undefined);
      }
      setIsOpen(isOpen);
    },
    [selValue, multiple, applyFilterCallback],
  );

  const clearFilter = useCallback(() => {
    if (selValue) {
      if (isOpen === true) {
        setIsOpen(false);
        setValue({ ...selValue, values: [] });
      } else {
        //setSelectedValue({ ...selValue, values: [] })
        applyFilterCallback({ ...selValue, values: [] });
        setSearch(undefined);
      }
    }
  }, [selValue, isOpen, applyFilterCallback]);

  const label = useMemo(() => {
    return selectedValue?.values && selectedValue?.values.length === 1
      ? selectedValue?.values[0].label
      : selectedValue?.values && selectedValue?.values.length > 1
        ? 'Multiple Selected'
        : defaultLabel;
  }, [selectedValue, defaultLabel]);

  const filteredOptions = useMemo(() => {
    if (options) {
      return options.filter(filterFunc);
    }
    return options;
  }, [options, filterFunc]);
  return (
    <Dropdown
      className={`${getIdClassNameHelper(filter.id)} filter-button-dropdown-${variant}`}
      as={ButtonGroup}
      onClick={() => onClickHandler()}
      autoClose={isSingle ? true : 'outside'}
      onToggle={onToggleCallback}
    >
      <div className="filter-toggle-button-label">
        {filter.name}&nbsp;
        {isFetching && (
          <Spinner
            className="filter-toggle-button-spinner"
            animation="border"
            size="sm"
            role="status"
          />
        )}
      </div>
      <Dropdown.Toggle
        className="filter-toggle-button"
        id={filter?.id}
        as={FilterToggleButtonComponent}
        label={filter.name}
        isFetching={isFetching}
      >
        <div>
          {label}
          &nbsp;
        </div>
      </Dropdown.Toggle>

      {!filter.required && selValue?.values && selValue?.values.length > 0 && (
        <div
          className="filter-toggle-button-clear"
          onClick={() => clearFilter()}
        >
          <X size="sm" />
        </div>
      )}

      <Dropdown.Menu className="filter-button-dropdown">
        {searchBox && (
          <Form.Control
            autoFocus
            className="filter-button-dropdown-search-input"
            placeholder="Search..."
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
          />
        )}
        <div className="filter-button-dropdown-menu">
          <MultipleSelectionOptionsComponent
            inputClassName={''}
            isLoading={isFetching}
            disabled={disabled}
            filter={filter}
            selectedValue={selectedValue}
            options={filteredOptions}
            changeValueCallback={changeMultipleValueHandler}
            MultipleSelectionOptionGroup={MultipleSelectionOptionSimple}
          />
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};
